<template>
  <BCol md="2">
    <div class="chapter-list-area">
      <BButton
          v-for="chapter in chapters"
          :disabled="!chapter.link || Object.keys(chapter.sentences).length === 0"
          @click="setCurrentChapter(chapter.id)"
          :key="chapter.id"
          :class="currentChapter && currentChapter.id === chapter.id ? 'unique-purple text-white rounded-lg' : null"
          variant="white"
          class="d-block w-100 mb-2 p-2 font-weight-bold shadow-none"
      >
        {{ chapter.name }}
      </BButton>
    </div>
  </BCol>
</template>

<script>
import * as chapterActions from './../../../../store/modules/Chapter/types/actions';
import Amplitude from 'amplitudejs';
import { mapActions } from "vuex";

export default {
  name: "ChapterList",
  props: {
    chapters: Array,
    currentChapter: Object
  },
  methods: {
    ...mapActions('Chapter', {
      getChapterById: chapterActions.GET_CHAPTER
    }),
    // setCurrentAudioByChapterId() {
    //   Amplitude.playNow( {url: this.currentChapter.link} );
    // },
    async setCurrentChapter(chapterId) {
      await this.getChapterById(chapterId);
      await this.setCurrentChapterId(chapterId);
      //await this.setCurrentAudioByChapterId();
    },
    setCurrentChapterId(chapterId) {
      this.$emit('setCurrentChapterId', chapterId);
    }
  }
}
</script>

<style scoped>
.unique-purple {
  background: #8E8AD3;
}
.chapter-list-area {
  overflow-y: auto;
  height: 50vh;
}
</style>